import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import { useLanguage } from "../../context/LanguageContext";
import "./style.css";

interface MobileMenuProps {
  onItemClick?: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ onItemClick }) => {
  const { t } = useLanguage();
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (onItemClick) onItemClick();
  };

  const menuItems = [
    { id: 1, title: t.nav.home, link: "/" },
    { id: 2, title: t.nav.about, link: "/about" },
    {
      id: 3,
      title: t.nav.services,
      link: "/service-details",
      submenu: t.services.items.map((s) => ({
        id: s.id,
        title: s.title,
        link: `/service-details/${s.slug}`,
      })),
    },
    { id: 4, title: t.nav.projects, link: "/project" },
    { id: 5, title: t.nav.contact, link: "/contact" },
  ];

  return (
    <ul className="responsivemenu">
      {menuItems.map((menu) => (
        <li key={menu.id} className={openId === menu.id ? "active" : ""}>
          {menu.submenu ? (
            <Fragment>
              <p
                onClick={() => handleToggle(menu.id)}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <span>{menu.title}</span>
                <i
                  className={
                    openId === menu.id ? "fa fa-angle-up" : "fa fa-angle-down"
                  }
                ></i>
              </p>

              <Collapse in={openId === menu.id} timeout="auto" unmountOnExit>
                <ul className="subMenu">
                  {menu.submenu.map((sub) => (
                    <li key={sub.id}>
                      <Link to={sub.link} onClick={handleClick}>
                        {sub.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Collapse>
            </Fragment>
          ) : (
            <Link to={menu.link} onClick={handleClick}>
              {menu.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MobileMenu;
